/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { OFFICIAL_URL } from '@/router/alias';

/**
 * 动态加载外部系统的登出 JS 并调用其 SilentLogout.logout 方法
 * 外部系统在对应 URL 提供 JS 文件，并将登出方法挂载到 window.SilentLogout.logout
 */
const externalLogout = (): Promise<void> => {
  return new Promise((resolve) => {
    const scriptUrl = `${OFFICIAL_URL}/js/publicJs/silentLogout.js`;
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.onload = () => {
      const win = window as Window &
        typeof globalThis & {
          SilentLogout?: { logout?: () => void };
        };
      if (win.SilentLogout && typeof win.SilentLogout.logout === 'function') {
        win.SilentLogout.logout();
      }
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      resolve();
    };
    script.onerror = () => {
      // 外部 JS 加载失败不阻塞本系统登出流程
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      resolve();
    };
    document.body.appendChild(script);
  });
};

export default externalLogout;
